const config = {
  alignClassPrefix: 'ql',
  tagTypes:         ['place', 'person', 'creation', 'event'],
}

export default config
